import { LoaderService } from "../../services/loader/loader.service";
import { Component, ViewEncapsulation } from "@angular/core";
import { animate, style, transition, trigger } from "@angular/animations";

@Component({
  selector: "app-loader",
  templateUrl: "./loader.component.html",
  styleUrls: ["./loader.component.css"],
  animations: [
    trigger("loaderAnimation", [
      transition(":enter", [
        style({ opacity: 0 }),
        animate("100ms", style({ opacity: 1 })),
      ]),
      transition(":leave", [
        style({  opacity: 1 }),
        animate("1000ms", style({  opacity: 0 })),
      ]),
    ]),
  ],
})
export class LoaderComponent {
  constructor(public loader: LoaderService) {}
}
